import React, { useEffect, useState } from 'react';
import { CenterRowDiv, Text, RowDiv, Div } from 'styles';
import { Switch } from 'components/form/switch/Switch';
import { LineText } from 'components/common/LineText';
import { CustomDate } from 'components/datepicker/CustomDate';
import { Spinner } from 'components/loading/Spinner';
import { TableChart } from './tableChart/TableChart';
import * as S from './TimeTableStyle';

export function TimeTable({ filters, onChange, switchList, timeList, loading, chartInputData, tableInputData, unit, chartOverrideOptions, onClickSearchDate, dateStartEndSearch, hourlyList }) {
  const [filteredHours, setFilteredHours] = useState([]);

  useEffect(() => {
    const timeFilter = filters.timeType || 'all';
    let newFilteredHours = [];
    let hours = Array.from({ length: 24 }, (_, i) => i);

    if (hourlyList && hourlyList.length > 0) {
      hours = hourlyList;
    }

    if (timeFilter === 'all') {
      // newFilteredHours = hours;
      newFilteredHours = hours.map((hour) => `${hour.toString().padStart(2, '0')}:00`);
    } else if (timeFilter === 'am') {
      // newFilteredHours = hours.slice(0, 12);
      newFilteredHours = hours.filter((hour) => hour < 12).map((hour) => `${hour.toString().padStart(2, '0')}:00`);
    } else if (timeFilter === 'pm') {
      // newFilteredHours = hours.slice(12, 24);
      newFilteredHours = hours.filter((hour) => hour >= 12).map((hour) => `${hour.toString().padStart(2, '0')}:00`);
    }

    setFilteredHours(newFilteredHours);
  }, [filters.timeType, tableInputData]);

  const renderSpinner = () => (
    <CenterRowDiv $justifyContent="center" $padding="10px">
      <Spinner $width={50} $height={50}/>
    </CenterRowDiv>
  )

  return (
    <>
      <S.DateDiv>
        {
          dateStartEndSearch ?
          <Div $padding="32px 0">
            <Text $type="b" $color="assistive" $marginBottom={4}>
              일자 선택
            </Text>
            <RowDiv $gap={8}>
              <CustomDate name="date" filters={filters} onChange={onChange} desc="From" hide />
              <CustomDate name="searchEndDate" filters={filters} onChange={onChange} desc="To" onClick={onClickSearchDate}/>
            </RowDiv>
          </Div>
          :
          <CustomDate label="일자 선택" name="date" filters={filters} onChange={onChange} onClick={onClickSearchDate}/>
        }
        {switchList && <Switch name="type" filters={filters} onChange={onChange} list={switchList} />}
      </S.DateDiv>

      { loading ?
        renderSpinner()
        :
        <TableChart filters={filters} chartInputData={chartInputData} chartOverrideOptions={chartOverrideOptions} unit={unit}/>
      }
      
      <S.TimeWrap>
        <CenterRowDiv $justifyContent="space-between">
          <LineText>시간대별 상세 데이터</LineText>
          <Switch name="timeType" filters={filters} onChange={onChange} list={timeList} />
        </CenterRowDiv>
        <Text $type="m12" $color="gray400" $textAlign="end" $padding="8px 0 4px">
          {unit && (`( 단위 ${unit} )`)}
        </Text>
        { loading ?
          renderSpinner()
          :
          <S.TableWrap>
            <S.BorderDiv>
              <S.TimeTable>
                <thead>
                  <tr>
                    <S.TableTh></S.TableTh>
                    {filteredHours.map((hour) => (
                      <S.TableTh key={hour}>{hour}</S.TableTh>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    tableInputData && tableInputData.map((data, index) => (
                      <tr key={index}>
                        <S.TableTh>{data.date}</S.TableTh>
                        {filteredHours.map((hour, i) => (
                          <td key={`hour_${i}`}>
                            <Text $type="m16" $color="assistive">
                              {
                                data.hourlyData.filter((h) => h.hour === hour).length > 0 && 
                                data.hourlyData.filter((h) => h.hour === hour)[0].value
                              }
                            </Text>
                          </td>
                        ))}
                      </tr>
                    ))
                  }
                </tbody>
              </S.TimeTable>
            </S.BorderDiv>
          </S.TableWrap>
        }
        
      </S.TimeWrap>
    </>
  );
}
